<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="items flex f15">
          搜索
          <span class="back">search</span>
        </div>
        <img src="../../assets/fireControl/group1.png" class="xiahua" />
        <div class="input">
          <van-search
            clearable
            @clear="clear()"
            v-model="value"
            show-left-icon
            placeholder="请输入选手编号或名称"
          >
            <template #left-icon>
              <img
                src="../../assets/fireControl/group4.png"
                alt=""
                style="vertical-align: middel"
              />
            </template>
          </van-search>
        </div>
        <div class="searchBtn">
          <van-button
            @click="gotoVote()"
            type="primary"
            style="background: linear-gradient(to bottom, #f65d3f, #e01f28)"
            >搜索</van-button
          >
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
    };
  },
};
</script>

<style lang="less" scoped>
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 9.2rem;
    height: 4.6666667rem;
    box-sizing: border-box;
    position: relative;
    .content {
      width: 96%;
      height: 5.0667rem;
      background: #fff;
      position: absolute;
      bottom: 0.2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;

      div.items {
        // height: 0.96rem;
        margin: 0.6333rem auto -0.2rem;
        width: 100%;
        color: rgb(179, 6, 6);
        box-sizing: border-box;
        position: relative;
        .back {
          position: absolute;
          color: rgba(221, 40, 34, 0.15);
        }
      }
      .xiahua {
        margin-left: calc(50% - 65px);
      }
      .input {
        margin: 0.5rem 0 0.4rem;
        box-sizing: border-box;
        .van-search {
          background: #ffe1af;
          border: 0.02rem solid #ccc;
          padding: 0;
          margin: 0 0.2666667rem;
          box-sizing: border-box;
          /deep/ ::placeholder {
            color: #cc0001;
          }
        }
      }
      .searchBtn {
        height: 0.76rem;
        line-height: 0.76rem;
        width: 30%;
        box-sizing: border-box;
        margin: 0 auto;
        .van-button {
          width: 100%;
          height: 100%;
          background: #c7171e;
          border: none;
          margin: 0;
          line-height: 0.76rem;
        }

        /deep/ .van-search .van-cell {
          padding: 0 8px 0px 0;
        }
      }
    }
  }
  div.close {
    margin-top: 0.5333333rem;
    .van-icon-close {
      font-size: 0.96rem;
      color: #fff;
    }
  }
}
</style>